<template>
  <vs-row row style="position:relative; top:30px;height: calc(100% - 75px);" wrap>
    <vs-col v-for="(interval, index) in scaleDefinition.intervals"
            :key="index"
            :style="'position:absolute;left:0;top:calc('+top(interval)+' - 16px)'"
            xs12>
      <span class="mb-0 pb-0 text-left text-small text-bold">{{ intervalLabel(interval.name) }}</span>
      <span class="my-0 ml-2 mr-0 pt-0 text-small text--disabled">{{ intervalRange(interval) }}</span>
    </vs-col>
  </vs-row>
</template>

<script>
export default {
  name: 'assessment-history-scale',
  props: {
    scaleDefinition: Object
  },
  data () {
    return {show: false};
  },
  mounted () {
    this.show = true;
  },
  methods: {
    intervalLabel (name) {
      return this.$t('assessments.simplifiedScoreScale').find(s => s.name === name).label;
    },
    intervalRange (interval) {
      if (interval.min && interval.max) {
        return `${interval.min} - ${interval.max}`;
      }
      if (interval.max) {
        return `< ${interval.max}`;
      }
      if (interval.min) {
        return `> ${interval.min}`;
      }
    },
    top (interval) {
      const fixedMinimum = !interval.min ? this.scaleDefinition.min : interval.min;
      const fixedMaximum = !interval.max ? this.scaleDefinition.max : interval.max;

      // eslint-disable-next-line no-mixed-operators
      return `${100 - (100 * ((fixedMinimum + (fixedMaximum - fixedMinimum) / 2) / (this.scaleDefinition.max - this.scaleDefinition.min)))}%`;
    }
  }
};
</script>

<style scoped>

</style>
